module.exports = __webpack_public_path__ + "static/profile-39cbe2109236e8072670b2f8a2209b73.png";